import { TabBar } from '@ksyos/design-system';
import { styled } from 'styled-components';
import { CarePathType } from '@common/enums/carePathType';
import { getSelectedLanguage } from '@frontend/translate';
import { useNavigateInTabBar } from '@frontend/utils/hooks/useNavigateInTabBar';

type FinancingTabProps = {
    selectedTab: CarePathType;
};

export function FinancingTabBar({ selectedTab }: FinancingTabProps): JSX.Element {
    const tabs = [CarePathType.old, CarePathType.flex];
    const { finance } = getSelectedLanguage();
    const { setSelectedTab } = useNavigateInTabBar();

    return (
        <StyledTabBar>
            {tabs.map((tab) => (
                <TabBar.Button
                    isSelected={selectedTab === tab}
                    key={tab}
                    onClick={() => setSelectedTab(tab)}
                >
                    {finance[tab]}
                </TabBar.Button>
            ))}
        </StyledTabBar>
    );
}

const StyledTabBar = styled(TabBar)`
    margin-bottom: 24px;
`;
